import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../core/services/auth.service';
import {tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class NoAuthGuard {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.auth.loggedOut$.pipe(
            tap(loggedOut => {
                if (!loggedOut) {
                    this.router.navigateByUrl('/');
                }
            })
        );
    }
}
